import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FundingEvaluation from "../../pages/Payment/FundingEvaluation.js";
import PaymentHistory from "../../pages/Payment/PaymentHistory.jsx";
import {
  SuccessPopup,
  PageLayout,
  UserRoute,
  CompetitionRule,
  ChallengesBoxM,
  AccountMetric,
  // SupportCenter,
  Profile,
  CompetitionList,
  LeaderboardParticipated,
  // PaymentHistory,
  Achievements,
  LeaderboardMobile,
  CompetitionOverview,
  CompetitionOverviewV2,
  Trademate,
  AffiliateMarketing,
  GettingStarted,
  NewDashboard,
  UnAuthCheckout,
  PaymentStatus,
  GetDocuSignSigningURL,
  DocuSignSigningCompleted,
  TradingPlatform,
  PageNotFound,
  NewWPCheckout,
} from "../../pages";

import Sumsub from "../../pages/profile/Sumsub";
import LeaderboardList from "../../pages/LeaderboardList";
import GoogleLogin from "../../pages/GoogleLogin";

import SignInNew from "../../pages/Auth/Signin/index.jsx";
import ResetPasswordNew from "../../pages/Auth/ResetPassword/index.jsx";
import PasswordOtpNew from "../../pages/Auth/PasswordOTP/index.jsx";
import NewCheckout from "../../pages/Checkout/NewCheckout.jsx";
import VerifyEmail from "../../pages/profile/VerifyEmail.jsx";
import CompFunding from "../Competition/CompFunding.jsx";
import AccountMetricPublicShare from "../Accountmetrics/PublicShare/Index.jsx";
import PublicShareCertificates from "../../pages/Achievements/ShareCertificates/index.jsx";
import AchievementPage from "../../pages/AchievementPage/AchievementPage.jsx";
import UpdatedNewCheckoutPage from "../../pages/UpdatedCheckoutPage/UpdatedCheckoutPaymentPage.jsx";
import TradeDetailsPage from "../../pages/View-trade/ViewTradeInfo.jsx";
import PrivateRoute from "../Routes/PrivateRoute.jsx";
import PublicRoute from "../Routes/PublicRoute.jsx";
import AffiliateDashboard from "../../pages/AffiliateMarketing/NewDashboard/NewDashboard.jsx";
import AffiliatePage from "../../pages/AffiliateMarketing/AffiliatePage.jsx";
import Coupons from "../../pages/Coupons/Coupons.jsx";
// import GoogleLogin from './../../pages/GoogleLogin';
import NavigationListener from "./../NavigationCom/index";

const fallbackStyle = {
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export default function MainRouter() {
  return (
    <div className="MainRouter">
      <Suspense fallback={<div style={fallbackStyle} />}>
        <BrowserRouter>
          <NavigationListener />
          <Routes>
            <Route
              path="/share/:platform/:accountId"
              element={<AccountMetricPublicShare />}
            />
            <Route
              path="/share-certificates/:certificateId"
              element={<PublicShareCertificates />}
            />
            {/* Public Routes */}
            <Route element={<PublicRoute />}>
              <Route path="/" element={<SignInNew />} />
              <Route path="/login" element={<SignInNew />} />
              <Route path="/signin" element={<SignInNew />} />
              <Route path="/signin/:token" element={<SignInNew />} />
              <Route path="/forgot-password" element={<SignInNew />} />
              <Route path="/ResetPassword" element={<ResetPasswordNew />} />
              <Route path="/enter-otp" element={<PasswordOtpNew />} />
              <Route path="/success" element={<SuccessPopup />} />
              <Route path="/auth/google" element={<GoogleLogin />} />
              <Route path="/signup/:referalCode" element={<SignInNew />} />
              <Route path="/signup" element={<SignInNew />} />
              {/* Public Share Routes */}

              <Route
                path="/FundingEvaluationPayment/:challenge_id"
                element={<UpdatedNewCheckoutPage publicCheckout={true} />}
              />
              {/* Public Checkout Route */}
            </Route>
            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              {/* <Route path="/test" element={<PageLayout headerName="Test"><Test /></PageLayout>}/> */}
              <Route
                path="/FundingEvaluationPayments/:challenge_id/:coupon_code/"
                element={<UpdatedNewCheckoutPage publicCheckout={false} />}
              />
              <Route
                path="/FundingEvaluationPayments/:challenge_id"
                element={<UpdatedNewCheckoutPage publicCheckout={false} />}
              />
              <Route
                path="/getting-started"
                element={
                  <PageLayout headerName="Get started">
                    <GettingStarted />
                  </PageLayout>
                }
              />

              <Route
                path="/achievements"
                element={
                  <PageLayout headerName="Achievements">
                    <Achievements />
                  </PageLayout>
                }
              />
              <Route
                path="/trading-platform"
                element={
                  <PageLayout headerName="Trading Platform">
                    <TradingPlatform />
                  </PageLayout>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PageLayout headerName="Dashboard">
                    <NewDashboard />
                  </PageLayout>
                }
              />
              <Route
                path="/AccountMetric"
                element={
                  <PageLayout headerName="Account Metric">
                    <AccountMetric />
                  </PageLayout>
                }
              />
              <Route path="/trade-details" element={<TradeDetailsPage />} />
              <Route
                path="/FundingEvaluation"
                element={
                  <PageLayout headerName="Funding Evaluation">
                    <FundingEvaluation />
                  </PageLayout>
                }
              />

              <Route
                path="/profile"
                element={
                  <PageLayout headerName="My Profile">
                    <Profile />
                  </PageLayout>
                }
              />
              <Route
                path="/verify-email/*"
                element={
                  <PageLayout headerName="Email Verification">
                    <VerifyEmail />
                  </PageLayout>
                }
              />
              <Route
                path="/competitionlist"
                element={
                  <PageLayout headerName="Competition List">
                    <CompetitionList />
                  </PageLayout>
                }
              />
              <Route
                path="/competitionlist/competitionCheckout"
                element={
                  <PageLayout headerName="Competition">
                    <CompFunding />
                  </PageLayout>
                }
              />
              <Route
                path="/competitionlist/:id"
                element={
                  <PageLayout headerName="Competition List">
                    <CompetitionList />
                  </PageLayout>
                }
              />
              <Route
                path="/leaderboardlist"
                element={
                  <PageLayout headerName="Leaderboard List">
                    <LeaderboardList />
                  </PageLayout>
                }
              />
              <Route
                path="/affiliateMarketing/*"
                element={
                  <PageLayout headerName="Affiliate Marketing">
                    {/* <AffiliateDashboard /> */}
                    {/* <AffiliateMarketing /> */}
                    <AffiliatePage />
                  </PageLayout>
                }
              />
              <Route
                path="/coupons"
                element={
                  <PageLayout headerName="Alpha Coupons">
                    <Coupons />
                  </PageLayout>
                }
              />
              <Route
                path="/affiliateMarketing?tab=2"
                element={
                  <PageLayout headerName="Affiliate Marketing">
                    <AffiliateMarketing />
                  </PageLayout>
                }
              />

              <Route
                path="/CompetitionRule"
                element={
                  <PageLayout headerName="Leaderboard">
                    <CompetitionRule />
                  </PageLayout>
                }
              />
              <Route
                path="/LeaderboardParticipated"
                element={
                  <PageLayout headerName="Leaderboard">
                    <LeaderboardParticipated />
                  </PageLayout>
                }
              />
              <Route
                path="/PaymentHistory"
                element={
                  <PageLayout headerName="Payment History">
                    <PaymentHistory />
                  </PageLayout>
                }
              />
              <Route
                path="/LeaderboardM"
                element={
                  <PageLayout headerName="Leaderboard">
                    <LeaderboardMobile />
                  </PageLayout>
                }
              />
              <Route
                path="/challengesBoxM"
                element={
                  <PageLayout headerName="Leaderboar">
                    <ChallengesBoxM />
                  </PageLayout>
                }
              />
              <Route
                path="/challengesBoxM"
                element={
                  <PageLayout headerName="Leaderboar">
                    <ChallengesBoxM />
                  </PageLayout>
                }
              />
              <Route
                path="/challengesBoxM"
                element={
                  <PageLayout headerName="Leaderboard">
                    <ChallengesBoxM />
                  </PageLayout>
                }
              />
              <Route
                path="/CompetitionOverview"
                element={
                  <PageLayout headerName="Competition Overview">
                    <CompetitionOverviewV2 />
                  </PageLayout>
                }
              />
              <Route
                path="/CompetitionOverview/:id"
                element={
                  <PageLayout headerName="Competition Overview">
                    <CompetitionOverviewV2 />
                  </PageLayout>
                }
              />
              <Route
                path="/Leaderboard"
                element={
                  <PageLayout headerName="Competition Overview">
                    <CompetitionOverview />
                  </PageLayout>
                }
              />
              <Route
                path="/Trademate"
                element={
                  <PageLayout headerName="Trademate">
                    <Trademate />
                  </PageLayout>
                }
              />

              <Route
                path="/sumsub"
                element={
                  <PageLayout headerName="Sumsub">
                    <Sumsub />
                  </PageLayout>
                }
              />
              <Route
                path="/docusign/get_signing_url/"
                element={
                  <PageLayout headerName="DigiSigner">
                    <GetDocuSignSigningURL />
                  </PageLayout>
                }
              />
              <Route
                path="/doc/signing_completed/"
                element={
                  <PageLayout headerName="DigiSigner">
                    <DocuSignSigningCompleted />
                  </PageLayout>
                }
              />
            </Route>
            <Route
              path="/evaluation/payment/success/"
              element={
                <PageLayout headerName="Payment Success">
                  <PaymentStatus success />
                </PageLayout>
              }
            />
            <Route
              path="/evaluation/payment/failure/"
              element={
                <PageLayout headerName="Payment Failed">
                  <PaymentStatus failed />
                </PageLayout>
              }
            />
            <Route
              path="/evaluation/payment/cancelled/"
              element={
                <PageLayout headerName="Payment Cancelled">
                  <PaymentStatus cancelled />
                </PageLayout>
              }
            />
            <Route
              path="/evaluation/payment/pending/"
              element={
                <PageLayout headerName="Payment pending">
                  <PaymentStatus pending />
                </PageLayout>
              }
            />{" "}
            <Route
              path="/payoutAchievements"
              element={
                <PageLayout headerName="Payout & Achievements">
                  <AchievementPage />
                </PageLayout>
              }
            />
            <Route path="*" element={<PageNotFound />} />
            {/* USER Protected Routes END */}
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}
